<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Commandes en cours</v-toolbar-title>
      </v-toolbar>

      <div class="text-center">
        <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            color="#01579B"
            top
        ></v-progress-linear>
      </div>
      <v-data-table
          :expanded.sync="expanded"
          :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus'
            }"
          :headers="headers"
          :items="loadcommands"
          :items-per-page="15"
          :search="search"
          :single-expand="singleExpand"
          no-data-text="Aucun résultat"
          no-results-text="Aucun résultat"
          show-expand
      >
        <template v-slot:[`top`]>
          <v-toolbar :elevation="0" class="mt-4 mb-4" color="white" flat>
            <v-btn large
            >
              <download-csv :data="loadcommands" name="commands.csv">
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                Télécharger CSV
              </download-csv>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field :id="dynamicID()"
                          append-icon="search"
                          hide-details
                          label="Rechercher..."
                          single-line
                          v-model="search"
            >
            </v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:[`item.isSent`]="{ item }">
          <v-chip :color="getColor(item.isSent)" dark>{{ item.isSent }}</v-chip>
        </template>
        <template v-slot:[`expanded-item`]="{ headers, item }">
          <td :colspan="headers.length">
            <vue-json-pretty :data="item"></vue-json-pretty>
          </td>
        </template>
        <template v-slot:[`item.createdDate`]="{ item }">
          {{ item.createdDate | formatDate }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "../../config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      search: "",
      loading: true,
      loadcommands: [],
      headers: [
        {text: "Date de création", sortable: false, value: "createdDate", width: "200px"},
        {text: "Emetteur", value: "senderId", sortable: false, width: "200px"},
        {text: "Empreinte digitale", value: "fingerprint", sortable: false, width: "200px"},
        {text: "Commande", value: "command", sortable: false, width: "200px"},
        {text: "Source", value: "fromWhere", sortable: false, width: "200px"},
        {text: "Destinataire", value: "commandIsFor", sortable: false, width: "200px"},
        {text: "Envoyé", value: "isSent", sortable: false},
        {text: "Statut", value: "status", sortable: false},
        {text: "Matricule agent", value: "userId", width: "200px"},
      ],
      expanded: [],
      singleExpand: true,
    };
  },
  created() {
    apiClient
        .get(`${this.$store.getters.user.baseUrl}/admin/commands`)
        .then((response) => {
          setTimeout(() => (this.loading = false), 3000);
          this.loadcommands = response.data.datas;
        })
        .catch(() => {
          this.loading = false;
        });
  },

  methods: {
    getColor(val) {
      if (val === "N") return "red";
      else if (val === "Y") return "green";
      else return "green";
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
  },
};
</script>
